import React from "react"
import HTMLContent from "dangerously-set-html-content";
import styles from "./embed-block.module.scss"

const EmbedBlock = ({ embed }) => {
  return <HTMLContent html={embed} className={styles.element} />
}

export default EmbedBlock